import { isString } from 'lodash';
import { UserAccess } from 'services/resources';

export const START_LOADING = 'app/services/Authentication/START_LOADING';

export const WHOAMI_SUCCESS = 'app/services/Authentication/WHOAMI_SUCCESS';
export const WHOAMI_FAIL = 'app/services/Authentication/WHOAMI_FAIL';

export const USER_AUTHENTICATION_SUCCESS = 'app/services/Authentication/USER_AUTHENTICATION_SUCCESS';
export const USER_AUTHENTICATION_FAIL = 'app/services/Authentication/USER_AUTHENTICATION_FAIL';

export const LOGOUT_SUCCESS = 'app/services/Authentication/LOGOUT_SUCCESS';

export const PASSWORD_RESET_REQUEST_SUCCESS = 'app/services/Authentication/PASSWORD_RESET_REQUEST_SUCCESS';
export const PASSWORD_RESET_REQUEST_FAIL = 'app/services/Authentication/PASSWORD_RESET_REQUEST_FAIL';
export const CONTACTLESS_AUTHENTICATION_SUCCESS = 'app/services/Authentication/CONTACTLESS_AUTHENTICATION_SUCCESS';
export const CONTACTLESS_AUTHENTICATION_FAIL = 'app/services/Authentication/CONTACTLESS_AUTHENTICATION_FAIL';
export const PASSWORD_RESET_SUCCESS = 'app/services/Authentication/PASSWORD_RESET_SUCCESS';
export const PASSWORD_RESET_FAIL = 'app/services/Authentication/PASSWORD_RESET_FAIL';
export const UNAUTHORIZED = 'app/services/Authentication/UNAUTHORIZED';
export const NETWORK_ERROR = 'app/services/Authentication/NETWORK_ERROR';
export const CLEAR_NETWORK_ERROR = 'app/services/Authentication/CLEAR_NETWORK_ERROR';

export const ACCOUNT_ACTIVATION_SUCCESS = 'app/services/authentication/ACCOUNT_ACTIVATION_SUCCESS';
export const ACCOUNT_ACTIVATION_FAIL = 'app/services/authentication/ACCOUNT_ACTIVATION_FAIL';

export const PROFILE_UPDATE_SUCCESS = 'app/services/authentication/PROFILE_UPDATE_SUCCESS';
export const PROFILE_UPDATE_FAIL = 'app/services/authentication/PROFILE_UPDATE_FAIL';

export const GET_LIST_ACCESS_SUCCESS = 'app/services/authentication/GET_LIST_ACCESS_SUCCESS';
export const GET_LIST_ACCESS_FAIL = 'app/services/authentication/GET_LIST_ACCESS_FAIL';

export const startLoading = () => ({
  type: START_LOADING,
});

export const receivedWhoamiSuccess = (user) => ({
  type: WHOAMI_SUCCESS,
  payload: { user },
});

export const receivedUpdatedProfileSuccess = (userProfile) => ({
  type: PROFILE_UPDATE_SUCCESS,
  payload: { userProfile },
});

export const receivedUpdatedProfileFail = (errors) => ({
  type: PROFILE_UPDATE_FAIL,
  payload: { errors },
});

export const receivedWhoamiFail = (errors) => ({
  type: WHOAMI_FAIL,
  payload: { errors },
});

export const receivedContactlessAuthFail = (errors) => {
  let payload = { errors };

  if (isString(errors)) {
    payload = {
      errors: {
        nonFieldErrors: [errors],
      },
    };
  }

  return {
    type: CONTACTLESS_AUTHENTICATION_FAIL,
    payload,
  };
};

export const receivedContactlessAuthSuccess = (token) => ({
  type: CONTACTLESS_AUTHENTICATION_SUCCESS,
  payload: { token },
});

export const receivedAuthenticationSuccess = (token) => ({
  type: USER_AUTHENTICATION_SUCCESS,
  payload: { token },
});

export const receivedUnauthorized = () => ({
  type: UNAUTHORIZED,
  payload: {},
});

export const receivedAuthenticationFail = (errors) => {
  let payload = { errors };

  if (isString(errors)) {
    payload = {
      errors: {
        nonFieldErrors: [errors],
      },
    };
  }

  return {
    type: USER_AUTHENTICATION_FAIL,
    payload,
  };
};

export const receivedLogoutSuccess = () => ({
  type: LOGOUT_SUCCESS,
});

export const receivedPasswordResetRequestSuccess = (message) => ({
  type: PASSWORD_RESET_REQUEST_SUCCESS,
  payload: { message },
});

export const receivedPasswordResetRequestFail = (errors) => ({
  type: PASSWORD_RESET_REQUEST_FAIL,
  payload: { errors },
});

export const receivedPasswordResetSuccess = (message) => ({
  type: PASSWORD_RESET_SUCCESS,
  payload: { message },
});

export const receivedPasswordResetFail = (errors) => ({
  type: PASSWORD_RESET_FAIL,
  payload: { errors },
});

export const receivedNetworkError = (errors) => ({
  type: NETWORK_ERROR,
  payload: { errors },
});

export const receivedClearNetworkError = () => ({
  type: CLEAR_NETWORK_ERROR,
});

export const receivedAccountActivationSuccess = (message) => ({
  type: ACCOUNT_ACTIVATION_SUCCESS,
  payload: { message },
});

export const receivedAccountActivationFail = (errors) => ({
  type: ACCOUNT_ACTIVATION_FAIL,
  payload: { errors },
});

export const receivedListAccessSuccess = (access: UserAccess) => ({
  type: GET_LIST_ACCESS_SUCCESS,
  payload: { access },
});

export const receivedListAccessFail = (errors) => ({
  type: GET_LIST_ACCESS_FAIL,
  payload: { errors },
});
